function windowHeight() {
  var windowHeight = window.innerHeight;
  return windowHeight;
}
function headerHeight() {
  if (document.body.contains(document.querySelector('[data-site-header]'))) {
    const headerHeight =
      document.querySelector('[data-site-header]').offsetHeight;
    //console.log(headerHeight);
    return headerHeight;
  } else {
    return;
  }
}
function cartFooter() {
  const cartFooterHeight =
    document.querySelector('.drawer__footer').offsetHeight;
  return cartFooterHeight;
}
function announcementHeight() {
  if (document.body.contains(document.querySelector('.announcement-bar'))) {
    const announcementHeight =
      document.querySelector('.announcement-bar').offsetHeight;
    if (announcementHeight == 0) {
      return 36;
    } else {
      return announcementHeight;
    }
  } else {
    return 0;
  }
}

function halfPageOffset() {
  if (document.body.contains(document.querySelector('.page-width'))) {
    const container = document.querySelector('.page-width');
    const offset = container.offsetLeft;
    return offset;
  }
}

document.documentElement.style.setProperty(
  '--window-height',
  windowHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--header-height',
  headerHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--half-page-offset',
  halfPageOffset() + 'px'
);
document.documentElement.style.setProperty(
  '--cart-footer-height',
  cartFooter() + 'px'
);
document.documentElement.style.setProperty(
  '--announcement-height',
  announcementHeight() + 'px'
);

window.addEventListener(
  'resize',
  debounce(function () {
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--window-height',
      windowHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--cart-footer-height',
      cartFooter() + 'px'
    );
    document.documentElement.style.setProperty(
      '--announcement-height',
      announcementHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--half-page-offset',
      halfPageOffset() + 'px'
    );

  

    //check overflow containers
    checkOverflow();

  }, 50)
);

// URL PARAMETERS
function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
}
/************ Smooth Scroll ****************/

function smoothScrollToAnchor(e) {
  // 1. Find the closest anchor that matches our criteria
  const anchor = e.target.closest('a[href*="#"]:not([href="#"]):not(.no-scroll):not([data-toggle-target])');
  if (!anchor) return;

  // 2. Ensure we are on the same page (don't interrupt links to other pages)
  if (
    location.pathname.replace(/^\//, '') !== anchor.pathname.replace(/^\//, '') ||
    location.hostname !== anchor.hostname
  ) {
    return;
  }

  // 3. Prevent default jump behavior
  e.preventDefault();

  const hash = anchor.hash;
  if (!hash) return;

  // Decode the ID in case of special characters (e.g., %20 for spaces)
  const elementId = decodeURIComponent(hash.slice(1));
  
  // Try to find by ID, fallback to finding by name attribute (for old-school anchors)
  const element = document.getElementById(elementId) || document.querySelector(`[name="${elementId}"]`);

  if (element) {
    // If you ever need to account for a sticky header, add its height here:
    // const headerOffset = document.querySelector('header')?.offsetHeight || 0;
    const headerOffset = 0;

    const targetPosition = element.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: targetPosition,
      left: 0,
      behavior: 'smooth'
    });
  }
}

// Use event delegation on the document. 
// This catches clicks on dynamically added links without needing to re-bind events.
document.addEventListener('click', smoothScrollToAnchor);




const scrollContainers = document.querySelectorAll('[data-horz-scroll]');


function checkOverflow() {
  scrollContainers.forEach((scrollContainer) => {
    if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
      scrollContainer.classList.add('overflowing');
    } else {
      scrollContainer.classList.remove('overflowing');
    }
  });
}
 
checkOverflow();
scrollContainers.forEach((scrollContainer) => {
  let isDragging = false;
  let startX;
  let scrollLeft;

  let velocity = 0;
  let rafId;

  function updateScroll() {
    if (!isDragging) return;
    scrollContainer.scrollLeft -= velocity;
    velocity *= 0.95; // Add friction
    if (Math.abs(velocity) > 0.75) {
      rafId = requestAnimationFrame(updateScroll);
    }
  }

  scrollContainer.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
    velocity = 0;
    cancelAnimationFrame(rafId);
  });

  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainer.offsetLeft;
    velocity = (x - startX) * 0.75; // Adjust speed
    startX = x;
    requestAnimationFrame(updateScroll);
  });

  scrollContainer.addEventListener('mouseup', () => {
    isDragging = false;
  });

  /*
// Touch support
scrollContainer.addEventListener("touchstart", (e) => {
    isDragging = true;
    startX = e.touches[0].pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
});

scrollContainer.addEventListener("touchend", () => {
    isDragging = false;
});

scrollContainer.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scroll speed
    scrollContainer.scrollLeft = scrollLeft - walk;
});
*/
});


 
  // Select all elements with the global data-animate attribute
  const animatedElements = document.querySelectorAll('[data-animate]');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target;
      
      // Check if the repeat flag is present
      const shouldRepeat = el.hasAttribute('data-animate-repeat');

      if (entry.isIntersecting) {
        // 1. Read the delay attribute (default to 0 if not provided)
        const delay = el.getAttribute('data-delay') || 0;
        
        // 2. Apply the delay dynamically (e.g., "500ms")
        el.style.animationDelay = `${delay}ms`;
        
        // 3. Add class to trigger the CSS animation
        el.classList.add('is-animating');
        
        // 4. If it should NOT repeat, stop watching it after the first time
        if (!shouldRepeat) {
          observer.unobserve(el);
        }
      } else {
        // Only remove the class (resetting the animation) if it's set to repeat
        if (shouldRepeat) {
          el.classList.remove('is-animating');
          // Clear the inline delay so it doesn't conflict on re-entry 
          // (it will be reapplied next time it enters)
          el.style.animationDelay = ''; 
        }
      }
    });
  }, { 
    threshold: 0.2 // Triggers when 20% of the element is visible
  });

  // Start observing each element
  animatedElements.forEach((el) => observer.observe(el));
 



// --- Standalone Helper Function for Quote Form ---
function populateQuoteModal(productTitle, productImageSrc, productImageSrcset) {
  const modalContent = document.querySelector('[data-modal-content="quoteForm"]');
  if (!modalContent) return;

  // 1. Update hidden input
  const hiddenTitleInput = modalContent.querySelector('[data-product-title]');
  if (hiddenTitleInput) hiddenTitleInput.value = productTitle;

  // 2. Update visible title
  const displayTitle = modalContent.querySelector('[data-quote-display-title]');
  if (displayTitle) displayTitle.innerHTML = productTitle;

  // 3. Update Image
  const modalImage = modalContent.querySelector('[data-product-image] img');
  if (modalImage && productImageSrc) {
    modalImage.src = productImageSrc;
    if (productImageSrcset) {
      modalImage.srcset = productImageSrcset;
    } else {
      modalImage.removeAttribute('srcset');
    }
    modalContent.classList.add('with-image');
    modalContent.classList.remove('general-quote'); // Reset general quote class if it was used
  } else {
    modalContent.classList.remove('with-image');
  }
}


  // --- Global Helper Function ---
// Parse Shopify Rich Text JSON into HTML. Can be used anywhere in your theme.
function parseShopifyRichText(richTextStr) {
  if (!richTextStr) return '';
  try {
    const data = JSON.parse(richTextStr);
    if (!data || !data.children) return '';

    const parseNode = (node) => {
      if (node.type === 'text') {
        let text = node.value || '';
        if (node.bold) text = `<strong>${text}</strong>`;
        if (node.italic) text = `<em>${text}</em>`;
        return text;
      }
      if (node.type === 'paragraph') return `<p>${(node.children || []).map(parseNode).join('')}</p>`;
      if (node.type === 'link') return `<a href="${node.url}">${(node.children || []).map(parseNode).join('')}</a>`;
      if (node.type === 'list') return `<ul>${(node.children || []).map(parseNode).join('')}</ul>`;
      if (node.type === 'list-item') return `<li>${(node.children || []).map(parseNode).join('')}</li>`;
      return '';
    };

    return data.children.map(parseNode).join('');
  } catch (e) {
    console.error('[parseShopifyRichText] Error parsing rich text:', e);
    return '';
  }
}
 